/* global axios */
import ApiClient from './ApiClient';

class BmtWhatsappOfficialCampaignsAPI extends ApiClient {
  constructor() {
    super('bmt_whatsapp_campaigns', { accountScoped: true });
  }

  uploadCsv(campaignId, file) {
    const fd = new FormData();
    fd.append('campaign_id', campaignId);
    fd.append('file', file);
    return axios.post(`${this.url}/upload_csv`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  trigger(id) {
    return axios.post(`${this.url}/${id}/trigger`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }

  leads(id, { page = 1, status = null } = {}) {
    return axios.get(`${this.url}/${id}/leads`, { params: { page, status } });
  }

  // Sprint #47.21 -- baixa XLSX com todos os leads da campanha
  exportLeads(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }
}

export default new BmtWhatsappOfficialCampaignsAPI();
